import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-contact.component',
  imports: [RouterLink],
  templateUrl: './contact.component.html',
})
export class ContactComponent {

}
